import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  rendezVousPart5WeekColumn,
  rendezVousPart5WeekColumnLessOpacity,
  rendezVousPart5WeekDate,
  rendezVousPart5WeekDateJour,
  rendezVousPart5WeekDateJourNombre,
  rendezVousPart5WeekDateMois,
  rendezVousPart5CollapseArrow,
  rendezVousPart5CreneauxDispos,
  rendezVousPart5CreneauxSubContainer,
  rendezVousPart5CreneauxCollapsed,
} from "./rendez-vous-part-5.module.scss"
import {
  RendezVousPart5WeekDate,
  RendezVousPart5WeekDateJourNombre,
  RendezVousPart5CreneauxDispos,
  RendezVousPart5CreneauxDisposChoisi,
} from "../rendez-vous-styled.js"
import Icon from "../../Icon/icon"

export const RendezVousPart5DayColumn = ({
  jour,
  creneauxDisponibles,
  changeWeekOffset,
  changeCreneau,
  creneauChoisi,
}) => {
  const [collapsed, setCollapsed] = useState(true)

  return (
    <div
      className={
        creneauxDisponibles.creneaux.length > 0
          ? rendezVousPart5WeekColumn
          : rendezVousPart5WeekColumnLessOpacity
      }
    >
      <RendezVousPart5WeekDate
        onClick={() => setCollapsed(!collapsed)}
        className={rendezVousPart5WeekDate}
      >
        <div className={rendezVousPart5WeekDateJour}>
          {creneauxDisponibles.jourLabel}
        </div>
        <RendezVousPart5WeekDateJourNombre
          className={rendezVousPart5WeekDateJourNombre}
        >
          {creneauxDisponibles.jourNombre}
        </RendezVousPart5WeekDateJourNombre>
        <div className={rendezVousPart5WeekDateMois}>
          {creneauxDisponibles.moisLabel}
        </div>
        <div className={rendezVousPart5CollapseArrow}>
          {collapsed ? (
            <Icon size={45} icon="chevron-thin-down"></Icon>
          ) : (
            <Icon size={45} icon="chevron-thin-up"></Icon>
          )}
        </div>
      </RendezVousPart5WeekDate>
      <div
        htmlFor={jour}
        className={`${rendezVousPart5CreneauxSubContainer} ${
          collapsed ? rendezVousPart5CreneauxCollapsed : ""
        }`}
      >
        {creneauxDisponibles.creneaux.map((heure, indexHeure) => {
          if (creneauChoisi === jour + " " + heure) {
            return (
              <RendezVousPart5CreneauxDisposChoisi
                key={heure}
                className={rendezVousPart5CreneauxDispos}
                onClick={() => changeCreneau("")}
              >
                {heure}
              </RendezVousPart5CreneauxDisposChoisi>
            )
          }
          return (
            <RendezVousPart5CreneauxDispos
              key={heure}
              className={rendezVousPart5CreneauxDispos}
              onClick={() => changeCreneau(jour + " " + heure)}
            >
              {heure}
            </RendezVousPart5CreneauxDispos>
          )
        })}
      </div>
    </div>
  )
}

RendezVousPart5DayColumn.propTypes = {
  jour: PropTypes.string,
  creneauxDisponibles: PropTypes.object,
  changeWeekOffset: PropTypes.func,
  changeCreneau: PropTypes.func,
  creneauChoisi: PropTypes.string,
  step: PropTypes.number,
}
